<template>
  <section>
    <AnalyticsPrint
      :infoBarItems="infoBarItems"
      :analyticsData="analyticsData"
      :hourData="hourData"
      :hideInfo="hideInfo"
      :roomsData="roomsData"
      :pdfTitleI18nKey="pdfTitleI18nKey"
      :includeRoomLineInPdf="includeRoomLineInPdf"
      :pdfFilenameSuffix="pdfFilenameSuffix"
      @donePrinting="$emit('donePrinting')"
    />
  </section>
</template>

<script>
import AnalyticsPrint from './AnalyticsPrint.vue'
export default {
  name: 'iframe-cmp',
  props: {
    infoBarItems: { type: Array, required: true },
    analyticsData: { type: Object, required: true },
    hourData: { type: Array, required: true },
    hideInfo: { type: Array, required: false },
    roomsData: { type: Array, required: false },
    pdfTitleI18nKey: { type: String, default: 'pdf_export_title_analytics' },
    includeRoomLineInPdf: { type: Boolean, default: false },
    pdfFilenameSuffix: { type: String, default: '' },
  },
  components: {
    AnalyticsPrint,
  },
}
</script>

<style></style>
